import script from "./PaywallFaq.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallFaq.vue?vue&type=script&setup=true&lang=js"

import "./PaywallFaq.vue?vue&type=style&index=0&id=e0c99866&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0c99866"]])

export default __exports__